import React from 'react';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

export default function Registeration() {
    window.scrollTo(0, 0)

    return (
        <>
            <div className="container-fluid account-content">
                <div className="row justify-content-center align-items-center">
                    <div id='register-form' className="col-11 col-sm-9 col-md-6 form-side d-flex flex-column justify-content-center align-items-center">
                        <h1 className='fw-semibold mb-5 text-center login-heading'>BECOME OUR MEMBER</h1>
                        <form action="" className='w-100'>
                            <div className="mb-3">
                                <input type="text" name='userName' className="form-control" placeholder='Full Name' required />
                            </div>
                            <div className="mb-3">
                                <input type="email" name='userEmail' className="form-control" placeholder='Email Address' required />
                            </div>
                            <div className="mb-3">
                                <input type="number" name='userPhone' className="form-control" placeholder='Phone Number' required />
                            </div>
                            <div className="mb-3">
                                <input type="text" name='userAddress' className="form-control" placeholder='Home Address' required />
                            </div>
                            <div className="mb-3">
                                <input type="password" name='userPassword' className="form-control" placeholder='Account Password' required />
                            </div>
                            <div className="mb-3">
                                <input type="password" name='userConfirmPassword' className="form-control" placeholder='Confirm Password' required />
                            </div>
                            <button type="submit" className="btn btn-primary login-btn fw-medium mt-3">Register</button>
                        </form>
                        <div className='m-0 p-0 mx-auto mt-4 account-bottom-links'>
                            <Link to="/my-account" className='text-decoration-none lost-password'>Already have an account? Log In</Link>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
